module.exports = __webpack_public_path__ + "img/CM-SL-CA-Nissan-Modern.0e8e09c4.jpeg";